var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandscaping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1d1d1d",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    stroke: "#1d1d1d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tree"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plant"
  }), /*#__PURE__*/React.createElement("g", {
    id: "flower"
  }), /*#__PURE__*/React.createElement("g", {
    id: "flower_pot"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rose"
  }), /*#__PURE__*/React.createElement("g", {
    id: "garden"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fance"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1,67.1l1.9-30c0-0.2,0-0.4-0.2-0.6l-10-15c-0.4-0.6-1.3-0.6-1.7,0l-10,15C74,36.6,74,36.9,74,37.1l0.4,5.9H60.6 l0.4-5.9c0-0.2,0-0.4-0.2-0.6l-10-15c-0.4-0.6-1.3-0.6-1.7,0l-10,15C39,36.6,39,36.9,39,37.1l0.4,5.9H25.6l0.4-5.9 c0-0.2,0-0.4-0.2-0.6l-10-15c-0.4-0.6-1.3-0.6-1.7,0l-10,15C4,36.6,4,36.9,4,37.1l2.1,32.7C4.8,71.5,4,73.7,4,76.1V78 c0,0.6,0.4,1,1,1h45h45c0.6,0,1-0.4,1-1v-4.9C96,70.9,95.3,68.8,94.1,67.1z M85,23.8l9,13.5l-1.8,27.8c-1.3-1-2.8-1.7-4.5-2 c-0.6-0.1-1.2-0.1-1.7-0.1c-1.1,0-2.2,0.2-3.3,0.6c-1.2-2.2-3-4.1-5.3-5.2l-1.4-21L85,23.8z M74.5,45l0.8,12H59.7l0.8-12H74.5z M59.6,59h5.8c-2.6,1.7-4.5,4.4-5.1,7.5c-0.4-0.2-0.7-0.3-1.1-0.4L59.6,59z M50,23.8l9,13.5l-1.8,28.6c-0.2,0-0.4,0-0.7,0 c-3.3,0.2-6,2.5-7,5.6c-1.3-1.5-3.3-2.5-5.9-2.6c-0.2,0-0.3,0-0.5,0l-2-31.6L50,23.8z M24.6,59h15.8l0.6,10.1 c-0.4,0.1-0.9,0.2-1.3,0.4c-1.1-5.4-6-9.5-11.8-9.5c-1.2,0-2.4,0.2-3.5,0.5L24.6,59z M39.5,45l0.8,12H24.7l0.8-12H39.5z M15,23.8 l9,13.5l-1.5,24.1c-2.2,1.1-4,2.9-5.1,5.1c-1.6-0.6-3.3-0.7-5-0.4C10.7,66.3,9.2,67,8,67.9L6,37.3L15,23.8z M6,76.1 c0-3.9,2.8-7.4,6.6-8c1.6-0.3,3.3-0.1,4.8,0.6c0.2,0.1,0.5,0.1,0.8,0c0.3-0.1,0.5-0.3,0.6-0.5c1-2.3,2.7-4.1,4.9-5.2 c0,0,0.1,0,0.1,0c1.3-0.6,2.7-0.9,4.2-0.9c5.3,0,9.6,4,10,9.2c0,0.4,0.2,0.7,0.6,0.8s0.7,0.1,1-0.1c1.1-0.8,2.5-1.2,3.9-1.1 C46.1,71,49,72.5,49,76v1H6V76.1z M94,77H51v-1v-1.9c0-0.3,0-0.6,0.1-0.9c0.4-2.9,2.7-5.1,5.5-5.3c0.5,0,0.9,0,1.3,0.1 c0.9,0.1,1.8,0.5,2.5,1c0.3,0.2,0.7,0.2,1,0.1c0.3-0.2,0.5-0.5,0.6-0.8C62.4,63,66.8,59,72,59c1.4,0,2.7,0.3,4,0.8c0,0,0,0,0,0 c0,0,0,0,0,0c2.4,1,4.3,2.9,5.2,5.3c0.1,0.3,0.3,0.5,0.6,0.5c0.3,0.1,0.5,0.1,0.8,0c1.5-0.7,3.1-0.9,4.8-0.6c1.9,0.3,3.6,1.4,4.9,3 l0,0c0,0,0,0,0,0c1.1,1.5,1.7,3.3,1.7,5.1V77z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "floral"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sunflower"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sprinkle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "water_hose"
  }), /*#__PURE__*/React.createElement("g", {
    id: "planting"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fertilizer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "butterfly"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shovel"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ladybug"
  }), /*#__PURE__*/React.createElement("g", {
    id: "watering"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hanging_pot"
  }), /*#__PURE__*/React.createElement("g", {
    id: "green_house"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscaping);
export default __webpack_public_path__ + "static/media/Landscaping.2c5ca2a9a000adc291e8cba76b3294b3.svg";
export { ForwardRef as ReactComponent };